// extracted by mini-css-extract-plugin
export default {"dialog-content":"LYeaf1_sTQ90Caxz4tnf","elongated-content":"S_tPY1Kga3bZKyxYrQ51","success-text-emphasised":"tgr6pMzDHNzwA41yxawC"};